module.exports = Em.Handlebars.compile("{{text-field value=value}}\n<input type=\"text\" class=\"color-field-spectrum\"/>\n");